import { render } from "./MenuGroupItem.vue?vue&type=template&id=2a4d57e8"
import script from "./MenuGroupItem.vue?vue&type=script&lang=js"
export * from "./MenuGroupItem.vue?vue&type=script&lang=js"

import "./MenuGroupItem.vue?vue&type=style&index=0&id=2a4d57e8&lang=css"
script.render = render

export default script